import React, { Component } from 'react';
import $ from 'jquery';
import Config from './Config';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, InputGroup, Input } from 'reactstrap';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import Header from '../components/Header';
import Editor from '../components/Editor';
import NewDocumentTypeConfigModal from '../components/modals/NewDocumentTypeConfigModal';
import TemplateEditorModal from '../components/modals/TemplateEditorModal'
import DocumentTypeTable from '../components/tables/DocumentTypeTable'
import { connect } from 'react-redux';
import AuthHOC from './Auth';
import { withAlert } from 'react-alert';
import { Flag } from 'flagger/react';
import { Stack, Typography, Button as MuiButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

class DocumentTypesView extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onDropDownclick = this.onDropDownclick.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleRawInputChange = this.handleRawInputChange.bind(this)
    this.showNewConfigModal = this.showNewConfigModal.bind(this)
    this.showTemplateEditorModal = this.showTemplateEditorModal.bind(this)
    this.refresh = this.refresh.bind(this)

    this.state = {
      dropdownOpen: false,
      documentTypes: [],
      associated_templates: [],
      displayTemplateEditorModal: false,
      displayNewConfigModal: false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentTypes')
      .then(res => res.json())
      .then(result => {
        this.setState({
          documentTypes: result,
          associated_templates: []
        })
      })
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  onDropDownclick(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let documentType = this.state.documentTypes.find(element => {
      return element.template == name
    })

    this.setState({
      template: documentType.template,
      html: documentType.html
    })
  }

  handleInputChange(html) {
    this.setState({
      html: html
    })
  }

  handleRawInputChange(html) {
    this.setState({
      rawhtml: html
    })
  }

  showNewConfigModal() {
    this.setState({
      displayNewConfigModal: !this.state.displayNewConfigModal
    })
  }

  showTemplateEditorModal() {
    this.setState({
      displayTemplateEditorModal: !this.state.displayTemplateEditorModal
    })
  }

  render() {

    let newreportmodel = {};

    if (this.state.displayNewConfigModal)
      newreportmodel = <NewDocumentTypeConfigModal visible={this.state.displayNewConfigModal} toggle={this.showNewConfigModal} refresh={this.refresh} />
    else
      newreportmodel = <div />

    return (
      <div className="App">
        <Header visible={!this.props.parsed.X3} />
        <div className="page-wrapper">
        <div className="s-page">
          <div className="s-page-header">
            <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: "left" }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {this.props.localisation['menu_header_document_type_configuration'] ? this.props.localisation['menu_header_document_type_configuration'].element_lang : 'Document Type Configuration'}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Configure document types and processing rules
              </Typography>
            </Stack>
            <div className="s-page-actions">
              <Flag flag="v12" entity={{ id: 1 }} case="off">
                <MuiButton
                  variant="contained"
                  startIcon={<AddIcon />}
                  disableElevation
                  type="button"
                  sx={{ textTransform: 'none' }}
                  onClick={this.showNewConfigModal}
                >
                  {this.props.localisation['document_type_config_new'] ? this.props.localisation['document_type_config_new'].element_lang : ''}
                </MuiButton>
              </Flag>
              <Flag flag="v12" entity={{ id: 1 }} case="on">
                <MuiButton
                  variant="contained"
                  startIcon={<AddIcon />}
                  disableElevation
                  type="button"
                  sx={{ textTransform: 'none' }}
                  onClick={this.showNewConfigModal}
                >
                  {this.props.localisation['document_type_config_new'] ? this.props.localisation['document_type_config_new'].element_lang : ''}
                </MuiButton>
              </Flag>
            </div>
          </div>
          <div className="s-content-panel">
          <InputGroup>
            <div className="text-editor" style={{ width: '100%' }}>
              <DocumentTypeTable
                delete={this.remove} 
                refresh={this.refresh} 
                onRowClicked={this.rowClicked} 
                logs={this.state.documentTypes} 
                associated_templates={this.state.associated_templates} 
                expandLogs={this.expandLogs}
                columnConfig={{ actions: true }}
              />
            </div>
          </InputGroup>
          {newreportmodel}
          </div>
        </div>
        </div>
      </div>
    );
  }
}
export default connect(state => state)(withAlert()(AuthHOC(DocumentTypesView, { name: 'document_type_configuration' })));
